export default __webpack_public_path__ + "static/media/arrow_back.89bf4906.svg";